export default "__VITE_ASSET__B0V3a6Rp__"